import type { ModuleManifest } from "./types";

export const policiesManifest: ModuleManifest = {
  name: "policies",
  label: "Policy",
  labelPlural: "Policies",
  coreBOSModule: "evPolicies",
  wsidPrefix: "73x",
  type: "standard",
  routes: {
    list: "/policies",
    show: "/policies/show/:id",
    create: "/policies/create",
    edit: "/policies/edit/:id",
  },
  navigation: {
    icon: "FileProtectOutlined",
    order: 3,
    group: "Compliance",
    hidden: false,
  },
  routing: {
    keywords: ["policy", "policies", "procedura", "regolamento"],
    searchFields: ["title"],
    defaultSort: { field: "title", order: "asc" },
  },
  context: { supported: true, entityKey: "policies" },
  fields: [
    { name: "title", label: "Titolo", type: "string", required: true },
    { name: "policytoaccount", label: "Account", type: "reference" },
    {
      name: "policystatus",
      label: "Stato",
      type: "picklist",
      options: [
        { value: "Draft", label: "Bozza" },
        { value: "Active", label: "Attiva" },
        { value: "Archived", label: "Archiviata" },
      ],
    },
    { name: "policyisactive", label: "Attiva", type: "boolean" },
    { name: "policy_type", label: "Tipo Policy", type: "picklist" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    {
      module: "Accounts",
      field: "policytoaccount",
      relation: "one-to-many",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documenti",
      icon: "FileOutlined",
      displayField: "notes_title",
    },
  ],
  requiredFields: ["title"],
  viewStrategy: "generic",
};
